import { hasAnyPermissions } from 'lib/functions/utils';
import { Tab } from 'lib/types/shared';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
import { AuthState } from '../../../../services/redux/authSlice';
import Blacklist from './Components/BlackList';
import CompanyComitees from './Components/Comitee';
import DecisionTreeConfig from './Components/DecisionEngines/components/Show';
import DecisonNodesFinal from './Components/DecisionNodes';
import WhiteList from './Components/Whitelist';

const tabs: Tab[] = [
  {
    label: 'Motores',
    component: <DecisionTreeConfig />,
    path: 'risk/engines',
    subPage: 'engines',
    index: 0,
  },
  {
    label: 'Nodos decisión',
    component: <DecisonNodesFinal />,
    path: 'risk/decisionNodes',
    subPage: 'decisionNodes',
    index: 1,
  },
  {
    label: 'Comités',
    component: <CompanyComitees />,
    path: 'risk/comitees',
    subPage: 'comitees',
    index: 2,
  },
  {
    label: 'WhiteList',
    component: <WhiteList />,
    path: 'risk/whitelists',
    subPage: 'whitelists',
    index: 3,
  },
  {
    label: 'BlackList',
    component: <Blacklist />,
    path: 'risk/blacklist',
    subPage: 'blacklist',
    index: 4,
  },
];

const RiskTab: React.FC = () => {
  const { subPage } = useParams<{
    subPage: string;
  }>();
  const navigate = useNavigate();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const [companyTabs, setCompanyTabs] = useState<Tab[]>([]);

  const [startValue, setStartValue] = useState(0);

  const setUpTabs = () => {
    const availableTabs = [];

    if (hasAnyPermissions(user, ['settings', 'settings_risk']))
      availableTabs.push(tabs[0]);
    if (hasAnyPermissions(user, ['settings', 'settings_risk']))
      availableTabs.push(tabs[1]);
    if (hasAnyPermissions(user, ['settings', 'settings_risk']))
      availableTabs.push(tabs[2]);
    if (hasAnyPermissions(user, ['settings', 'settings_risk']))
      availableTabs.push(tabs[3]);
    if (
      hasAnyPermissions(user, [
        'settings',
        'settings_risk',
        'settings_risk_blacklist_view',
      ])
    )
      availableTabs.push(tabs[4]);

    setCompanyTabs(availableTabs);

    const startValueFind = availableTabs.findIndex(
      (x) => x.subPage === subPage,
    );

    if (startValueFind !== -1) return setStartValue(startValueFind);
    setStartValue(0);
  };

  const handleNavigation = (index: number) => {
    navigate(`/settings/${companyTabs[index].path}`);
  };

  useEffect(() => {
    setUpTabs();
  }, []);

  return (
    <EnhancedTab
      startValue={startValue}
      tabs={companyTabs}
      onTabChange={handleNavigation}
    />
  );
};

export default RiskTab;
